<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {}
  }
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,body,#app{
  height: 100%;
}
#app {
  overflow: hidden;
  font-family: "Source Han Sans CN", "Times New Roman";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #252525;
  font-size: 12px;
  background-color: #fff;
}
#app>div{
  height: 100%;
  overflow: scroll;
}
</style>
